module.exports = __webpack_public_path__ + "static/img/advance03.12e7b8c6.png";